import { gql } from '@apollo/client';

export const GET_JOB_POSTING_QUESTIONNAIRE = gql`
  query GetJobPostingQuestionnaire($tenantId: String) {
    getJobPostingQuestionnaire(tenantId: $tenantId) {
      questions {
        id
        questionTitle
        answerType
        required
        priority
        options {
          label
          value
          priority
        }
      }
    }
  }
`;
